webpackJsonp([35783957827783],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _buttonModule = __webpack_require__(104);
	
	var _buttonModule2 = _interopRequireDefault(_buttonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button(props) {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Button.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _buttonModule2.default.container },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.to, download: this.props.filename, target: '_blank', className: _buttonModule2.default.button },
	        this.props.children
	      )
	    );
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-PageComponents-Button----button-module---container---1iwIp","button":"src-components-PageComponents-Button----button-module---button---3HEtN"};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timelineModule = __webpack_require__(333);
	
	var _timelineModule2 = _interopRequireDefault(_timelineModule);
	
	var _TimelineBox = __webpack_require__(220);
	
	var _TimelineBox2 = _interopRequireDefault(_TimelineBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timeline = function (_React$Component) {
	  _inherits(Timeline, _React$Component);
	
	  function Timeline(props) {
	    _classCallCheck(this, Timeline);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Timeline.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: _timelineModule2.default.container },
	      _react2.default.createElement(
	        "div",
	        { className: _timelineModule2.default.timeline },
	        _react2.default.createElement(_TimelineBox2.default, {
	          year: "2024",
	          content: "Member of the European Academy of Sciences and Arts"
	        }),
	        _react2.default.createElement(_TimelineBox2.default, {
	          year: "2023",
	          content: "The IEEE Fourier Award for Signal Processing"
	        }),
	        _react2.default.createElement(_TimelineBox2.default, {
	          year: "2020",
	          content: "International member of the (USA) National Academy of Engineering"
	        }),
	        _react2.default.createElement(_TimelineBox2.default, {
	          year: "2016",
	          content: "The (Centennial) UBC Faculty of Applied Science Dean's Medal of Distinction"
	        }),
	        _react2.default.createElement(_TimelineBox2.default, {
	          year: "2013",
	          content: "UBC Killam Award for Excellence in Mentoring recognizing outstanding mentorship of numerous graduate students over many years"
	        }),
	        _react2.default.createElement(_TimelineBox2.default, {
	          year: "2008",
	          content: "The highest award of IEEE Signal Processing Society, the \"Norbert Wiener Society Award\". It honors outstanding technical contributions and outstanding leadership in the signal processing field"
	        }),
	        _react2.default.createElement(_TimelineBox2.default, {
	          year: "2007",
	          content: "The R.A. Machlachlan Award, the highest award of the Association of Professional Engineers in BC, emphasizing significant technical contributions and leadership to engineering \"that characterize the profession at its best\""
	        }),
	        _react2.default.createElement(_TimelineBox2.default, {
	          year: "1999",
	          content: "The first woman in Electrical Engineering to become a Fellow of the Royal Society of Canada"
	        })
	      )
	    );
	  };
	
	  return Timeline;
	}(_react2.default.Component);
	
	exports.default = Timeline;
	module.exports = exports["default"];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timelineboxModule = __webpack_require__(332);
	
	var _timelineboxModule2 = _interopRequireDefault(_timelineboxModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimelineBox = function (_React$Component) {
	  _inherits(TimelineBox, _React$Component);
	
	  function TimelineBox(props) {
	    _classCallCheck(this, TimelineBox);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  TimelineBox.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: _timelineboxModule2.default.timelinebox },
	      _react2.default.createElement(
	        "div",
	        { className: _timelineboxModule2.default.year },
	        _react2.default.createElement(
	          "p",
	          null,
	          this.props.year
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _timelineboxModule2.default.content },
	        _react2.default.createElement(
	          "p",
	          null,
	          this.props.content
	        )
	      )
	    );
	  };
	
	  return TimelineBox;
	}(_react2.default.Component);
	
	exports.default = TimelineBox;
	module.exports = exports["default"];

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"timelinebox":"src-components-PageComponents-Timeline-TimelineBox----timelinebox-module---timelinebox---1A2zj","year":"src-components-PageComponents-Timeline-TimelineBox----timelinebox-module---year---1cWLP","content":"src-components-PageComponents-Timeline-TimelineBox----timelinebox-module---content---3Nc_T"};

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-PageComponents-Timeline----timeline-module---container---Lpvrm","timeline":"src-components-PageComponents-Timeline----timeline-module---timeline---zfc5d"};

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cvrababw.dd4f63fc.pdf";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/main1.b29a0717.jpg";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mainpic.a93c5b28.jpg";

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pagesModule = __webpack_require__(24);
	
	var _pagesModule2 = _interopRequireDefault(_pagesModule);
	
	var _mainpic = __webpack_require__(488);
	
	var _mainpic2 = _interopRequireDefault(_mainpic);
	
	var _main = __webpack_require__(487);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _Timeline = __webpack_require__(219);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _Button = __webpack_require__(77);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _cvrababw = __webpack_require__(347);
	
	var _cvrababw2 = _interopRequireDefault(_cvrababw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import Link from 'gatsby-link'
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: _pagesModule2.default.container1 },
	      _react2.default.createElement(
	        "div",
	        { className: _pagesModule2.default.intro1 },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Dr. Rabab K. Ward is a Professor Emeritus in the Electrical and Computer Engineering Department at the University of British Columbia, Canada. She is the first woman appointed as professor in engineering in British Columbia. She has around 40 years of post-doctoral experience in education, research and leadership. Her research contributions are in broad areas of signal processing, including signal detection; image encoding, recognition, and restoration, and their applications in cable TV, HDTV, medical imaging, infant cry signals, and brain computer interfaces. Dr. Ward has published upwards of 240 refereed journal papers, 350 refereed conference articles, and holds eight patents related to monitoring, measurement, and noise reduction concerning cable television. Some of her work has been licensed to US and Canadian industry."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "She has supervised 47 Ph.D. and 50 Master students. She has served and provided leadership to IEEE and other professional societies. She was President of the IEEE Signal Processing Society (2016-2017) and IEEE Director Division 1X (2020-2021)."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { to: _cvrababw2.default, filename: "CV_Rabab_Ward.pdf" },
	            "CV"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _pagesModule2.default.container2 },
	      _react2.default.createElement(
	        "div",
	        { className: _pagesModule2.default.intro2 },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Dr. Rabab K. Ward is a Professor Emeritus in the Electrical and Computer Engineering Department at the University of British Columbia, Canada. She is the first woman appointed as professor in engineering in British Columbia. She has around 40 years of post-doctoral experience in education, research and leadership. Her research contributions are in broad areas of signal processing, including signal detection; image encoding, recognition, and restoration, and their applications in cable TV, HDTV, medical imaging, infant cry signals, and brain computer interfaces. Dr. Ward has published upwards of 240 refereed journal papers, 350 refereed conference articles, and holds eight patents related to monitoring, measurement, and noise reduction concerning cable television. Some of her work has been licensed to US and Canadian industry."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "She has supervised 47 Ph.D. and 50 Master students. She has served and provided leadership to IEEE and other professional societies. She was President of the IEEE Signal Processing Society (2016-2017) and IEEE Director Division 1X (2020-2021)."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { to: _cvrababw2.default },
	            "CV"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _pagesModule2.default.timelineheader },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Selected Honors"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _pagesModule2.default.timelinecontainer },
	        _react2.default.createElement(_Timeline2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-5248114d4f70ae4e1b7b.js